import React from 'react';
import PropTypes from 'prop-types';

// COMPONENTS
import Loader from '../Loader/Loader';

// STYLES
import styles from './Button.module.css';

const Button = (({ handleSubmit, label, customContainerStyles, disabled, id, theme, isLoading, hidden }) => {
  // Get accessible label text - handle both string and node types
  const getLabelText = () => {
    if (typeof label === 'string') {
      return label;
    }
    // If label is a React node, try to extract text content
    if (label && typeof label === 'object' && label.props && label.props.children) {
      if (typeof label.props.children === 'string') {
        return label.props.children;
      }
    }
    return '';
  };

  const labelText = getLabelText();
  const ariaLabel = labelText || (typeof label === 'string' ? label : 'Button');

  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      if (handleSubmit) {
        handleSubmit();
      }
    }
  };

  return (
    <div
      id={id}
      onClick={disabled ? () => {} : handleSubmit}
      onKeyDown={handleKeyDown}
      hidden={hidden}
      className={[
        "bg-dark dark:bg-button text-white px-4 flex items-center justify-center",
        styles.buttonContainer,
        theme === 'Dark' ? styles.darkTheme : styles.lightTheme,
        disabled && theme === 'Dark' ? styles.isDisabledDark : null,
        disabled && theme === 'Light' ? styles.isDisabledLight : null,
        customContainerStyles
      ].join(' ')}
      tabIndex={disabled ? -1 : 0}
      role="button"
      aria-label={ariaLabel}
      aria-disabled={disabled}
    >
      {isLoading ? <Loader height={30} /> : <p>{label}</p>}
    </div>
  );
})


Button.propTypes = {
  handleSubmit: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  customContainerStyles: PropTypes.any, //eslint-disable-line
  disabled: PropTypes.bool,
  id: PropTypes.string,
  theme: PropTypes.string,
  isLoading: PropTypes.bool,
  hidden: PropTypes.bool
}

Button.defaultProps = {
  disabled: false,
  id: null,
  theme: 'Dark',
  isLoading: false,
  handleSubmit: null,
  hidden: false
}

export default Button;
